export default __webpack_public_path__ + "0fe8be394fc25b258f5af7af27b99d09.png";